const COLS = 10;

const CELL_VARIANTS = [
  ['max-w-16', 'max-w-10', 'max-w-20', 'max-w-8',  'max-w-14', 'max-w-24', 'max-w-10', 'max-w-16', 'max-w-6',  'max-w-12'],
  ['max-w-12', 'max-w-16', 'max-w-10', 'max-w-14', 'max-w-8',  'max-w-16', 'max-w-20', 'max-w-10', 'max-w-14', 'max-w-8'],
  ['max-w-20', 'max-w-8',  'max-w-14', 'max-w-12', 'max-w-16', 'max-w-10', 'max-w-8',  'max-w-20', 'max-w-12', 'max-w-16'],
  ['max-w-8',  'max-w-14', 'max-w-6',  'max-w-20', 'max-w-10', 'max-w-14', 'max-w-16', 'max-w-8',  'max-w-20', 'max-w-10'],
  ['max-w-14', 'max-w-12', 'max-w-16', 'max-w-6',  'max-w-20', 'max-w-8',  'max-w-12', 'max-w-14', 'max-w-10', 'max-w-20'],
  ['max-w-10', 'max-w-20', 'max-w-8',  'max-w-16', 'max-w-6',  'max-w-20', 'max-w-14', 'max-w-12', 'max-w-16', 'max-w-6'],
];

export function ContentTrackerTableSkeleton() {
  return (
    <div className="overflow-hidden h-full animate-pulse">
      {/* Header */}
      <div className="flex items-center px-4 py-3 bg-slate-50 border-b border-slate-200">
        {Array.from({ length: COLS }).map((_, i) => (
          <div key={i} className="flex-1 px-2">
            <div className="h-2.5 rounded-full bg-slate-200 max-w-16" />
          </div>
        ))}
      </div>

      {/* Rows */}
      {Array.from({ length: 25 }).map((_, rowIdx) => {
        const variant = CELL_VARIANTS[rowIdx % CELL_VARIANTS.length];
        return (
          <div
            key={rowIdx}
            className="flex items-center px-4 py-3.5 border-b border-slate-100 last:border-0"
          >
            {Array.from({ length: COLS }).map((_, colIdx) => (
              <div key={colIdx} className="flex-1 px-2">
                <div className={`h-3.5 rounded bg-slate-100 ${variant[colIdx]}`} />
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}
